/* lua.js generated code 0.3.0 */
let HomeSceneBtn = require("clover/scene/component/homescene/HomeSceneButton")
let UserNewReward = require("clover/logic/userTask/UserNewReward")
var SendToDesktopButton = xClass("SendToDesktopButton2", HomeSceneBtn)
SendToDesktopButton.prototype.ctor = function (btnLayer) {
    let self = this
    let image = "adapter/send_to_desktop2.png"
    let text = '收藏有礼'

    self.btnLayer = btnLayer

    let action1 = cc.ScaleBy.create(0.5, 0.95, 1.05)
    let action2 = cc.ScaleBy.create(0.5, 1 / 0.95, 1 / 1.05)
    let anim = cc.RepeatForever.create(cc.Sequence.create(
        action1,
        action2
    ))
    self.rewardAnim = anim
    HomeSceneBtn.prototype.ctor.call(self, text, image)
}

SendToDesktopButton.prototype.customInit = function () {
    var self = this

    self.btnLayer = require("clover/scene/HomeScene").getInstance().btnLayer

    self.imageNode.setScale(0.55, 0.55)
    //let size = self.node.getContentSize()
    //size.width *= 0.55
    //size.height *= 0.55
    //self.node.setContentSize(size)

    var redDotTimestamp = cc.UserDefault.getInstance().getIntegerForKey(LOCAL_SHORTCUT_RED_DOT)
    var diffDays = (new Date().getTime() - redDotTimestamp) / (1000 * 60 * 60 * 24)
    self.showRedDot = diffDays >= 7 && !GameProxy.getInstance().isFromShortcut()

    self.inited = true
    //self.text.setPositionY(-size.height / 2)
    self.text.setPositionY(-40)
    self.update(!UserNewReward.getInstance().isShortCutRewardGet())
}
SendToDesktopButton.prototype.update = function (showRewardIcon) {
    var self = this
    if (!self.inited) {
        return
    }
    self.showRewardIcon = showRewardIcon
    if (showRewardIcon) {
        if (!self.rewardIcon) {
            self.rewardIcon = cc.Sprite.createWithSpriteFrameName("homeScene/rewardDot.png")
            self.rewardIcon.setPosition(27, 30)
            self.node.addChild(self.rewardIcon)
            self.imageNode.runAction(self.rewardAnim)
        }

    } else{
        if (self.rewardIcon) {
            self.removeChild(self.rewardIcon)
            self.imageNode.stopAllActions()
            self.rewardIcon = null;
        }
        self.text.setString("发送桌面")

        // 如果从快捷方式进来的，不显示红点，否则，七天内如果也没使用过快捷方式，就显示红点
        if (self.showRedDot) {
            if (!self.redDot) {
                // self.redDot = cc.Sprite.createWithSpriteFrameName("reddot/reddot.png")
                self.redDot = cc.Sprite.createWithSpriteFrameName("h5library/reddot.png")
                // self.redDot.setScale(0.15)
                self.redDot.setPosition(35, 38)
                self.node.addChild(self.redDot)
                self.imageNode.runAction(self.rewardAnim)
            }
        } else {
            if (self.redDot) {
                self.redDot.removeFromParent()
                self.imageNode.stopAllActions()
                self.redDot = undefined
            }
        }
    }
    self.activitiesButtonRedDot = self.showRewardIcon || self.showRedDot
    if (self.onRedDotChange) {
        self.onRedDotChange(self.activitiesButtonRedDot)
    }
}

SendToDesktopButton.prototype.onCick = function (callFunc, needPoser) {
    var self = this

    if (self.isBusy) {
        return
    }
    self.isBusy = true
    let curPos = self.convertToWorldSpace(cc.p(self.imageNode.getPosition()))
    if (!self.inActivitiesPanel) {

        cc.UserDefault.getInstance().setIntegerForKey("send_to_desktop_icon_clicked", 1)
        self.btnLayer.removeSendToDesktopBtn()

        // 加到折叠面板里
        let btn = require("clover/scene/component/homescene/SendToDesktopButton2").create(self.btnLayer)
        self.btnLayer.activitiesButtonIcon.addBtn(btn)
        self.btnLayer.sendToDesktopBtn = btn
        btn.inActivitiesPanel = true
        self.isBusy = false
    }

    GameGuide.getInstance().forceStop()

    DCAssist.userTrack("shortcut_reward", "desktop_create") // 点击按钮打点
    var needGetReward = !UserNewReward.getInstance().isShortCutRewardGet();
    function onSuccess() {
        cc.UserDefault.getInstance().setIntegerForKey(LOCAL_SHORTCUT_RED_DOT, new Date().getTime())
        // 创建成功，删除红点，并记录时间
        if (self.showRedDot) {
            self.showRedDot = false
            self.update(self.showRewardIcon)
        }
        
        if (needGetReward) {
            self.getReward(curPos)
        }
        self.isBusy = false
    }
    function onCancel(desc) {
        Toast.make(desc)
        DCAssist.userTrack("shortcut_reward", "cancel")
        self.isBusy = false
    }
    function onFail(desc) {
        Toast.make(desc)
        DCAssist.userTrack("shortcut_reward", "fail")
        self.isBusy = false
    }
    GameProxy.getInstance().addShortcut(onSuccess, onFail, onCancel)
}

SendToDesktopButton.prototype.getReward = function (pos) {
    var self = this

    var newReward = MetaManager.getInstance().getSetShortcutRewards()
    self.config = newReward
    UserNewReward.getInstance().getShortCutRewards(function () {
        self.playItemAnimation(function () {
            self.update(!UserNewReward.getInstance().isShortCutRewardGet())
            self.isBusy = false;

        }, pos)
    }, function (error) {
        self.update(!UserNewReward.getInstance().isShortCutRewardGet())
        self.isBusy = false;
    })
    DCAssist.userTrack("shortcut_reward", "get_reward");
}
SendToDesktopButton.prototype.playItemAnimation = function (onAnimFinish, pos) {
    var self = this
    var flyItemConfig = table()
    var $limit62 = $len(self.config)
    for (var i = 1; i <= $limit62; i += 1) {
        var config = table()
        let index = i
        if (self.infiniteEnergyIcon) {
            index = i + 1
        }
        config.itemId = self.config[index].itemId
        config.num = self.config[index].num
        config.pos = pos
        table.insert(flyItemConfig, config)
    }

    HomeSceneAnimation.playGetPropAnimation(flyItemConfig, onAnimFinish, 0.15)

}
SendToDesktopButton.prototype.itemPos = table([1, 3, table(
    [1, 1, table([0, 25], [0, -137])],
    [1, 2, table([0, 35], [0, -137])],
    [1, 3, table([0, 45], [0, -137])]
)])
var itemScale = table([1, 2, table(0.60, 0.79)], [1, 3, table(0.55, 0.72)], [1, 4, table(0.5, 0.65)])

module.exports = SendToDesktopButton
